module.exports = __webpack_public_path__ + "img/se.44fd2006.svg";